import { IFileUploadConfig } from './types';

let config: IFileUploadConfig | null = null;

export function configureFileUpload(options: IFileUploadConfig): void {
  config = options;
}

export function getConfig(): IFileUploadConfig {
  if (!config) {
    throw new Error(
      'FileUpload module is not configured. Call configureFileUpload() before using file upload functions.'
    );
  }
  return config;
}

export function getDefaultPreviewImage(): string {
  return config?.defaultPreviewImage ?? '';
}
